// Dependencies
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import Input from 'components/atoms/Input';
import ManagerBase from 'components/baseClass/ManagerBase';
import { PADGE_LIMIT } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { portRecords } from 'services/ports';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { OpenModal, PortType, RootState } from 'types';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface PortsComponentProps {
    active: boolean;
    opendMenu?: boolean;

    //unused props
    port: PortType;
    setSystemLoadingAction: SetSystemLoadingAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    openModelFunction: OpenModal;
    dateTimeFormat: DateTimeFormat;
}

interface PortsComponentState {
    active: boolean;
    opendMenu?: boolean;

    page: number;
    limit: number;
    searchFor: string[];
    order: {
        type: string;
        order: string;
    };
    searchQuery: any;
    searchValue: string;
    filterQuery: any;
    loading: boolean;
    pages: number;
    total: number;
    items: any[];
}

class Ports extends ManagerBase<PortsComponentProps, PortsComponentState> {
    constructor(props: PortsComponentProps) {
        super(props);
        this.state = {
            active: false,
            searchFor: ['name', 'client_name'],
            opendMenu: false,
            searchValue: '',
            pages: 0,
            page: 1,
            limit: PADGE_LIMIT,
            total: 0,
            order: { type: 'id', order: 'desc' },
            searchQuery: {},
            filterQuery: {},
            loading: false,
            items: [],
        };
    }

    static getDerivedStateFromProps(props: PortsComponentProps, state: PortsComponentState) {
        if (props.active !== state.active || props.opendMenu !== state.opendMenu) {
            return {
                active: props.active,
                opendMenu: props.opendMenu,
            };
        }

        return null;
    }

    componentDidMount(): void {
        this.getData();
    }

    getData = () => {
        this.setState({ loading: true }, () => {
            portRecords({
                page: this.state.page, // send page number
                limit: this.state.limit,
                order: this.state.order, // send order value
                search: this.state.searchQuery, // send search value
                filter: this.state.filterQuery,
            })
                .then((res) => {
                    //update state and save the data
                    this.setState({
                        pages: Math.ceil(res.total / this.state.limit),
                        total: res.total,
                        items: res.items,
                        loading: false,
                    });
                    this.props.setSystemLoadingAction(false);
                })
                .catch((error) => {
                    this.props.setErrorHandlerAction(error);
                });
        });
    };

    //unused function
    handleToggleCreatePort = () => {
        this.props.openModelFunction(
            'createPortModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('createPortModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    //unused function
    handleToggleEditPort = (port) => {
        this.props.openModelFunction(
            'editPortModel',
            0,
            'medium',
            { port },
            {
                onCancel: () => {
                    this.props.openModelFunction('editPortModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    //unused function
    setFilter = (filterQuery) => {
        this.setState({ filterQuery }, this.getData);
    };

    togglDeletePort = (port) => {
        this.props.openModelFunction(
            'deletePortModel',
            0,
            'medium',
            { port },
            {
                onCancel: () => {
                    this.props.openModelFunction('deletePortModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    togglInitDefaultValue = (port) => {
        this.props.openModelFunction(
            'initDefaultValueModal',
            0,
            'medium',
            { port },
            {
                onCancel: () => {
                    this.props.openModelFunction('initDefaultValueModal');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    !this.state.active && 'hidden',
                    'mt-14',
                    'h-page',
                    'border-gray-300',
                    'padding-transition',
                    'fixed',
                    'z-10',
                    'left-0',
                    'right-0',
                    'margin-transition',
                    this.state.opendMenu ? 'ml-menu w-main' : 'ml-14 w-fullPage'
                )}
            >
                <div className="flex no-select h-12 justify-between border-b border-gray-300  px-2">
                    <div className=" py-2  flex items-center">
                        <div className="py-0 px-0 w-1/4">
                            <FormGroup required={false} className="mb-0 mt-0 relative">
                                <Input
                                    value={this.state.searchValue}
                                    name="search"
                                    type="search"
                                    onChange={this.search}
                                    className="py-1 pl-5 w-48"
                                ></Input>
                                <Icon className="absolute left-1 bottom-1 mb-1  w-4 h-4">
                                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                    <path d="M21 21l-6 -6" />
                                </Icon>
                            </FormGroup>
                        </div>
                    </div>
                    <div className=" py-2 flex justify-end"></div>
                </div>
                <div className="grid  no-select h-10 grid-cols-24 border-b border-gray-300  ">
                    <div className=" py-2 col-span-2 flex items-center">
                        {this.renderOrder('id')}
                        {translate('#')}
                    </div>
                    <div className=" py-2 col-span-10 flex items-center">
                        {this.renderOrder('name')}
                        {translate('name')}
                    </div>
                    <div className=" py-2 col-span-3 flex items-center">
                        {this.renderOrder('status')}
                        {translate('status')}
                    </div>

                    <div className=" py-2 col-span-3 flex items-center">
                        {this.renderOrder('Date last update')}
                        {translate('updated_at')}
                    </div>
                    <div className=" py-2 col-span-3 flex items-center">
                        {this.renderOrder('created_at')}
                        {translate('created date')}
                    </div>
                    <div className=" py-2 col-span-3 flex items-center">{translate('OPTIONS')}</div>
                </div>
                {this.state.loading ? (
                    <div
                        style={{
                            height: 'calc( 100vh - 190px)',
                        }}
                        className="flex items-center justify-center "
                    >
                        <div className="flex justify-start items-center gap-1 max-w-3xl mx-auto text-center  leading-9   text-gray-900">
                            <Image src="/static/images/loading.svg" className="mx-auto w-4" alt="error" />
                            <p>{translate('Loading, Please Wait...')}</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <Scrollbars
                            renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
                            renderTrackHorizontal={() => <div style={{ display: 'none' }} />}
                            style={{
                                height: 'calc( 100vh - 190px)',
                            }}
                        >
                            {this.state.items.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={twclsx(
                                            'grid',
                                            'raw',
                                            'grid-cols-24',
                                            'border-b',
                                            'border-gray-300',

                                            'relative'
                                        )}
                                    >
                                        <div className=" py-2 px-2 col-span-2">{item.id}</div>
                                        <div className=" py-2 col-span-10 flex items-center gap-4">
                                            <div>{item.name}</div>
                                            <div className="text-sm">{item.client_name}</div>
                                        </div>
                                        <div className=" py-2 col-span-3  ">{translate(item.status)}</div>
                                        <div className=" py-2 col-span-3  ">
                                            {this.props.dateTimeFormat
                                                .parseDateTime(item.updated_at)
                                                .formatDateTimeToString('dd MMM yyyy HH:mm Z')}
                                        </div>
                                        <div className=" py-2 col-span-3  ">
                                            {this.props.dateTimeFormat
                                                .parseDateTime(item.created_at)
                                                .formatDateTimeToString('dd MMM yyyy HH:mm Z')}
                                        </div>

                                        <div className=" py-2 gap-1  col-span-2  ">
                                            {item.status === 'inactive' ? (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.togglDeletePort(item);
                                                    }}
                                                    className="px-2 py-0 bg-primary-delete text-sm rounded-md text-white"
                                                >
                                                    {translate('Delete')}
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.togglInitDefaultValue(item);
                                                    }}
                                                    className="px-2 py-0 bg-primary-submit text-sm rounded-md text-white "
                                                >
                                                    {translate('Default values')}
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </Scrollbars>
                    </>
                )}
                <div className="flex h-10 p-1 justify-between border-t border-gray-300  ">
                    <div className="w-36 flex text-center ">{this.renderPages()}</div>
                    <p className="  py-2 px-2 text-gray-700">
                        {translate('pagination', {
                            showingFrom: (this.state.page - 1) * this.state.limit + 1,
                            showingTo:
                                (this.state.page - 1) * this.state.limit + this.state.limit > this.state.total
                                    ? this.state.total
                                    : (this.state.page - 1) * this.state.limit + this.state.limit,
                            of: this.state.total,
                        })}
                    </p>
                </div>
            </div>
        );
    }
}

const portsStateToProps = (state: RootState) => ({
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    openModelFunction: state.layout.openModelFunction,
});

const portsDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(portsStateToProps, portsDispatchToProps)(Ports);
